import { render, staticRenderFns } from "./BaseTransactionDetailsChargeback.vue?vue&type=template&id=60be5e9e&scoped=true&"
import script from "./BaseTransactionDetailsChargeback.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetailsChargeback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be5e9e",
  null
  
)

export default component.exports